import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchPost, objectify } from '../../utils';
export const fetch = async (query: { SupplierProductId: string; filters: any; Page: number; Sort: string; SortDirection: string; BatchSize: number }) => {
    const { SupplierProductId, filters, Page, Sort, SortDirection, BatchSize = DEFAULT_PAGE_SIZE } = query;
    const respType = 'Inline';

    return fetchPost(
        `/SupplierProductEnquiry/SupplierProduct/${SupplierProductId}/SearchLinks`,
        filters && { ...filters },
        { BatchPage: Page, BatchSize, Sort: Sort && SortDirection && `${Sort}:${SortDirection}` },
        respType
    )
        .then(
            (result) => {
                if (result) {
                    if (result.Links) {
                        return {
                            records: result.Links.map((item) => objectify(item, null, 'Inline')),
                            nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
                            currPage: result.BatchInformation && result.BatchInformation.BatchPage,
                        };
                    } else {
                        return result;
                    }
                }

            });
};
